export default [
    { name:'adventure', path: '/adventure', component: () => import('@/views/adventure/index'), meta: {
        roles: ['student']
    } },
]